import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Footer.module.css';

const HIDE_ON = ['/', '/login'];

const Footer: React.FC = () => {
  const { pathname } = useLocation();
  if (HIDE_ON.includes(pathname)) return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.footerLinks}>
        <Link to="/learn" className={styles.footerLink}>
          Learn
        </Link>
        <span className={styles.footerSep}>&middot;</span>
        <Link to="/glossary" className={styles.footerLink}>
          Glossary
        </Link>
        <span className={styles.footerSep}>&middot;</span>
        <Link to="/terms" className={styles.footerLink}>
          Terms of Service
        </Link>
        <span className={styles.footerSep}>&middot;</span>
        <Link to="/privacy" className={styles.footerLink}>
          Privacy Policy
        </Link>
        <span className={styles.footerSep}>&middot;</span>
        <Link to="/risk-disclosure" className={styles.footerLink}>
          Risk Disclosure
        </Link>
      </div>
      <p>&copy; {new Date().getFullYear()} SignalDeck. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
